export default __webpack_public_path__ + "static/media/IMG_00009.5527e7d1.jpeg";